import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, List, ListItem, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { Template } from "../../services/api";
import { DefaultSetID } from "../../services/api/TemplateSets";
import { DefaultContentCell, DefaultHeaderCell, StripedTableRow } from "../../theme";
import TemplateRowAction from "./TemplateRowAction";

const TemplatesTable: React.FC<{ templates: Template[]; templateSetNameMap: Map<string, string> }> = ({
  templates,
  templateSetNameMap,
}) => {
  const navigate = useNavigate();
  const renderTemplateSetLink = (id: string) => {
    const displayText = `${id} - ${templateSetNameMap.get(id)}`;
    return id === DefaultSetID ? displayText : <Link to={`/template-sets/${id}`}>{displayText}</Link>;
  };

  return (
    <>
      <Stack direction="row" sx={{ padding: "3px" }} alignItems="right" justifyContent="flex-end">
        <Button
          sx={{ float: "right" }}
          size="small"
          variant="contained"
          onClick={() => {
            navigate("/templates/upload");
          }}
        >
          Add New Profile
        </Button>
      </Stack>
      <TableContainer sx={{ marginTop: "10px" }}>
        <Table sx={{ margin: "auto" }}>
          <TableHead>
            <TableRow>
              <DefaultHeaderCell sx={{ minWidth: 250 }}>Name</DefaultHeaderCell>
              <DefaultHeaderCell sx={{ minWidth: 200 }}>Prefix</DefaultHeaderCell>
              <DefaultHeaderCell>Color Space</DefaultHeaderCell>
              <DefaultHeaderCell>Segment Length</DefaultHeaderCell>
              <DefaultHeaderCell sx={{ minWidth: 250 }}>Description</DefaultHeaderCell>
              <DefaultHeaderCell sx={{ minWidth: 250 }}>Mapped Sets</DefaultHeaderCell>
              <DefaultHeaderCell>Action</DefaultHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((template) => (
              <StripedTableRow key={template.name}>
                <DefaultContentCell>
                  <Link to={`/encoding-profiles/${template.name}`}>{template.name}</Link>
                </DefaultContentCell>
                <DefaultContentCell>{template.prefix}</DefaultContentCell>
                <DefaultContentCell sx={{ maxWidth: 100 }}>{template.color_space}</DefaultContentCell>
                <DefaultContentCell sx={{ maxWidth: 80 }}>{template.segment_length}</DefaultContentCell>
                <DefaultContentCell>{template.description}</DefaultContentCell>
                <DefaultContentCell>
                  <List>
                    {template.set_ids?.map((id) => (
                      <ListItem key={id} dense disableGutters>
                        {renderTemplateSetLink(id)}
                      </ListItem>
                    ))}
                  </List>
                </DefaultContentCell>
                <DefaultContentCell>
                  <TemplateRowAction template={template} />
                </DefaultContentCell>
              </StripedTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplatesTable;
